import { Box, Modal } from '@mui/material'
import React from 'react'
import BookingRequestsCard from '../components/Cards/BookingRequestCard'
import ServicesCard from '../components/Cards/ServicesCard'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  maxHeight: '90vh',
  overflow: 'auto',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  outline: 'none',
  borderRadius: '16px',
  textAlign: 'center',
}

const BookingRequestsModal = ({
  handleBookingRequestsModal,
  toggleBookingRequestsModal,
  requestedBookings = [],
  getRequestedBookings,
}) => {
  
  return (
    <div>
      <Modal
        open={toggleBookingRequestsModal}
        onClose={() => handleBookingRequestsModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="booking-request-modal">
          <div className="text-center">
            <h3 className="fs-24 fw-bold">Booking Requests</h3>
            <div className="row m-0 gy-3">
              {requestedBookings &&
                requestedBookings?.length > 0 &&
                requestedBookings?.map((booking, index) => (
                  <div className="col-12" key={booking?.id}>
                    <ServicesCard
                      booking={booking}
                      // isNewBooking={true}
                      getRequestedBookings={getRequestedBookings}
                    />
                  </div>
                ))}
              {requestedBookings?.length === 0 && (
                <p className='fs-20 mt-3'>No bookings requests at the moment.</p>
              )}
            </div>
            {/* <div className="mt-3">
              <div className="mt-2">
                <ServicesCard showDistance={false} jobTitle={'Makeup'} />
              </div>
              <div className="mt-2">
                <ServicesCard showDistance={false} jobTitle={'Makeup'} />
              </div>
              <div className="mt-2">
                <ServicesCard showDistance={false} jobTitle={'Makeup'} />
              </div>
            </div> */}
          </div>
        </Box>
      </Modal>
    </div>
  )
}

export default BookingRequestsModal
